export default {
  newDesign: true,
  parameters: {
    landing_id: "BRLquizTC",
    segment: 42,
  },
  title: "Cursos de programação para crianças de 8 a 17 anos em uma escola internacional | Kodland",
  downtimeUrl: "https://www.kodland.org/pt",
  startPage: {
    title:
      "Responda às perguntas para se inscrever na sua primeira aula experimental",
    subtitle:
      "Mostraremos como transformar a paixão por gadgets em uma vantagem:<br>💬 Descubra os talentos do seu filho de forma divertida<br>🌐 Tudo o que você precisa é de um computador e conexão com a internet<br>💙 Confiado por mais de 100.000 pais",
    image: {
      url: "/welcome/longquiz_br_dev_desktop.webp",
      style: {
        height: "100%",
        "max-height": "100vh",
      },
    },
    imageMobile: {
      url: "/welcome/longquiz_br_dev_mob.webp",
      style: {
        width: "100%",
      },
    },
    button: " Vamos lá! 🔥 ",
  },
  stopPage: {
    image: "/welcome/quizV2/no-computer.png",
    title: "Obrigado por confiar em nossa plataforma educacional!",
    subtitle:
      "Infelizmente, tablets ou telefones não são adequados para assistir às nossas aulas. Ficaremos felizes em vê-lo em nossas aulas na próxima vez!",
  },
  quizRotateBySteps: {
    1: {
      title: "Quantos anos tem o seu filho?",
      type: "age",
      button: "",
    },
    2: {
      question: "O que seu filho gosta de fazer no tempo livre?",
      answers: [
        "Praticar esportes ou brincar ao ar livre ⚽",
        "Ler livros ou quadrinhos 📚",
        "Assistir TV, YouTube ou jogar videogames 🎮",
        "Passar tempo com amigos ou familiares 👫",
        "Outro 🙂"
      ],
    },
    3: {
      question: "Como seu filho se sente em relação ao aprendizado online?",
      answers: [
        "Eles adoram e acham envolvente 💻❤️",
        "Preferem o aprendizado presencial 🙂",
        "Eles têm dificuldade para manter o foco 😵‍💫",
        "Eles nunca tentaram aprender online ❓"
      ],
    },
    4: {
      typeInfo: "noQuestions",
      imageLink: "/welcome/brazil_graph.webp",
      subtitle: "Embora seja recomendado que as crianças não passem mais de 2 horas por dia em dispositivos, na América Latina frequentemente ultrapassam as 5 horas. É aconselhável alternar entretenimento com atividades produtivas, como aulas de 1 a 1,5 horas.<br><br>Nossos programas foram projetados com isso em mente.",
      button: "Muito bem",
    },
    5: {
      question: "Na escola, o que seu filho mais gosta de fazer? ",
      answers: [
        "Experimentos de ciências ou desafios de matemática 🧪🔢",
        "Ler e escrever histórias 📚✍️",
        "Arte, música ou atividades criativas 🎨🎶",
        "Educação física ou esportes 🏃‍♀️🏋️‍♂️",
        "Outro 🙂"
      ],
    },
    6: {
      question: "Seu filho gosta de construir ou projetar coisas (por exemplo, com Lego, arte, quebra-cabeças)?",
      answers: [
        "Sim, ele adora construir e projetar coisas 🧩🏗️",
        "Às vezes, mas ele prefere outras atividades 🤔",
        "Não, ele não tem muito interesse nisso 🙅‍♂️",
      ],
    },
    7: {
      question: "Como seu filho aprende ou lembra melhor das coisas novas?",
      answers: [
        "Vendo (aprende de forma visual) 👁️",
        "Fazendo (aprende praticando) 👐",
        "Ouvindo (aprende auditivamente) 🎧",
        "Através de repetição e prática 🔄✏️"
      ],
    },
    8: {
      question:
        "Seu filho tem acesso a um laptop ou computador para estudar?",
      answers: [
        "Sim, ele tem o próprio dispositivo 💻✅",
        "Sim, mas ele compartilha com outras pessoas 🖥️👫",
        {
          answer: "Não, ele não tem acesso regular 🚫",
          stopAnswer: true,
        },
      ],
    },
    9: {
      question: "Quais atividades atraem seu filho?",
      answers: [
        "Esportes ou dança ⚽💃",
        "Artes criativas 🎨🖌️",
        "Atividades intelectuais 🧩♟️💻",
        "Jogos ou vídeos 🎮📺",
        "Outro 🙂"
      ],
    },
    10: {
      question: "Como seu filho trabalha em grupo?",
      answers: [
        "Gosta de colaborar 🤝💡",
        "Prefere liderar 🧑‍⚖️",
        "Trabalha de forma independente, mas contribui 👤✔️",
        "Fica tímido ou desconfortável 😳",
      ],
    },
    11: {
      question: "Qual papel seu filho costuma desempenhar em atividades de grupo?",
      answers: [
        "Ele gosta de liderar e organizar 🧑‍⚖️🗂️",
        "Ele gosta de contribuir com ideias e colaborar 🤝💡",
        "Prefere ouvir e seguir 👂🙂",
        "Tenta mediar ou resolver conflitos ⚖️🕊️",
        "Ele se sente tímido e fica no fundo 😳"
      ],
    },
    12: {
      typeInfo: "noQuestions",
      imageLink: "/welcome/quiz_br_2.webp",
      subtitle: "Oferecemos formatos de aprendizado tanto individuais quanto em grupo, adaptando cuidadosamente o processo para atender à idade e às necessidades de cada criança.",
      button: "Vamos lá!",
    },
    13: {
      question: "Seu filho já demonstrou interesse em aprender a programar ou codificar?",
      answers: [
        "Sim, já começou a aprender 💻🚀",
        "Sim, tem curiosidade, mas ainda não tentou 🤔💡",
        "Ainda não, mas talvez se interesse 🤷‍♂️",
        "Não, não está interessado 🙅‍♀️"
      ],
    },
    14: {
      question: "Qual é o gênero do seu filho?",
      answers: [
        "Masculino 👦",
        "Feminino 👧",
        "Prefiro não dizer 🤐"
      ],
    },
    15: {
      question: "Quais atividades ou matérias seu filho mais gosta?",
      answers: [
        "Leitura ou escrita 📚✍️",
        "Arte, música ou teatro 🎨🎶🎭",
        "Esportes ou atividades físicas 🏃‍♀️⚽",
        "Tecnologia ou computadores 💻📱",
        "Outro 🙂"
      ],
    },
    16: {
      question: "Seu filho gosta de criar coisas ou fazer atividades com amigos?",
      answers: [
        "Sim, adora projetos criativos em grupo 👫🎨",
        "Às vezes, depende da atividade 🤔",
        "Não, prefere tarefas individuais 👤💡"
      ],
    },
    17: {
      question: "Seu filho está confortável com tecnologia?",
      answers: [
        "Muito confortável, usa frequentemente 💻✔️",
        "Consegue tarefas básicas, mas precisa de orientação 🖱️❓",
        "Não está familiarizado 🚫"
      ],
    },
    18: {
      typeInfo: "noQuestions",
      imageLink: "/welcome/brazil_fwd.webp",
      subtitle: "Na Kodland, os alunos projetam modelos 3D, criam quadrinhos, constroem jogos e desenvolvem programas de computador. Atualmente, 30.000 crianças em todo o mundo estão aprendendo conosco!",
      button: "Ótimo!",
    },
    19: {
      question: "Como seu filho lida com desafios ou problemas?",
      answers: [
        "Ele tenta resolver sozinho 💪🧠",
        "Pede ajuda quando necessário 🙋‍♀️✔️",
        "Fica frustrado e desiste facilmente 😤",
        "Gosta de resolver problemas e vê isso como um desafio 🕵️‍♂️"
      ],
    },
    20: {
      question: "Seu filho tem interesse em criar suas próprias histórias ou personagens?",
      answers: [
        "Sim, ele adora contar histórias e tem muitas ideias ✍️🌟",
        "Às vezes, mas precisa de incentivo 🤗",
        "Não, ele não tem muito interesse nisso 🚫",
      ],
    },
    21: {
      question: "Como seu filho lida com tarefas que exigem atenção e pensamento lógico?",
      answers: [
        "Ele é bom em se concentrar e resolver problemas 🎯🧩",
        "Se sai bem com alguma orientação ou estrutura 🗂️🤝",
        "Dificuldade em focar em tarefas detalhadas 😵‍💫",
      ],
    },
    22: {
      question: "Quando seu filho conta uma história, ele tende a...",
      answers: [
        "Focar em muitos detalhes e descrições 📝📜",
        "Ir direto ao ponto principal 🎯",
        "Adicionar humor ou imaginação à história 🤪✨",
        "Lutar para organizar seus pensamentos 🤔"
      ],
    },
    23: {
      question: "Como seu filho normalmente reage ao tentar algo novo?",
      answers: [
        "Ele mergulha de cabeça com entusiasmo 🎉🚀",
        "Fica curioso, mas cauteloso 🤔👣",
        "Fica nervoso e precisa de incentivo 😬🤗",
        "Adora experimentar por conta própria 🛠️🔬",
        "Resiste a tentar coisas novas 🙅‍♂️"
      ],
    },
    24: {
      question: "Seu filho prefere seguir instruções ou criar suas próprias ideias?",
      answers: [
        "Ele adora instruções claras e completar tarefas 📋✔️",
        "Prefere ideias criativas e novas abordagens 🎨💡",
        "Fica nervoso e precisa de incentivo 😬🤗",
        "Gosta de uma mistura de estrutura e liberdade ⚖️🛠️",
        "Depende da tarefa – estrutura ou criatividade 🤷‍♂️"
      ],
    },
    25: {
      typeInfo: "noQuestions",
      imageLink: "/welcome/brazil_review.webp",
      subtitle: "Somos recomendados por pais de todo o mundo. Esperamos que em breve você se junte a eles 💙",
      button: "Estamos quase lá",
    },
    26: {
      question: "O que motiva seu filho a manter o foco em uma tarefa?",
      answers: [
        "Um objetivo claro ou recompensa no final 🎯🏅",
        "Empolgação ou paixão pela tarefa ✨❤️",
        "Trabalhar em grupo 🤝💬",
        "Feedback positivo ou incentivo durante o processo 👏😊",
        "Um senso de competição ou desafio 🥇🔥"
      ],
    },
    27: {
      question: "Sobre o que seu filho gosta de falar em suas histórias ou tópicos?",
      answers: [
        "Aventuras, mistérios ou fantasia 🗺️🐉",
        "Ciência, tecnologia ou invenções 🔬💻",
        "Histórias engraçadas ou bobas 🤪😂",
        "Eventos reais ou história 📜🌍",
        "Histórias sobre amizades ou emoções ❤️👫"
      ],
    },
    28: {
      question: "O que faz seu filho se sentir orgulhoso ou realizado?",
      answers: [
        "Completar uma tarefa desafiadora 🏆🧠",
        "Ajudar os outros ou contribuir 🤝❤️",
        "Aprender algo novo 📚✨",
        "Receber feedback positivo 🥳👏",
        "Resolver um problema complicado 🔍🧩"
      ],
    },
    29: {
      typeInfo: "noQuestions",
      imageLink: "/welcome/quiz_br_1.webp",
      subtitle: "Seu plano de aprendizado está quase pronto 🎉<br><br>Inscreva-se para uma aula experimental, onde vamos te contar tudo sobre ela. Selecione uma data e horário para um encontro pessoal.",
      button: "Selecionar",
    },
    30: {
      title: "Agende uma aula gratuita",
      type: "one-page-contacts",
      subtitle: "",
      button: "Quase lá! 🔥",
    },
    31: {
      title: "",
      type: "timeslot",
      subtitle: "",
      button: "",
    },
    32: {
      title:
        "Obrigado 🎉 Faltam apenas alguns passos para concluir o cadastro",
      typeInfo: "pc-laptop",
      subtitle:
        "Por favor, observe que você precisará de um PC ou laptop funcional para a aula e que deve acompanhar seu filho durante toda a aula. Lembre-se de que a aula é individual e personalizada.",
      button: "O que mais?",
    },
    33: {
      title: "Verifique seu e-mail e WhatsApp antes da aula experimental 📞",
      typeInfo: "whatsapp",
      subtitle:
        "Enviaremos um lembrete 24 horas antes da aula e 2 horas antes da aula pediremos para você confirmar sua presença. É muito importante que mantenhamos contato para que a aula não seja cancelada.",
      button: "O que mais?",
    },
    34: {
      title: "A aula vai acontecer na nossa plataforma 💻",
      typeInfo: "classroom",
      subtitle:
        "Você vai receber um link e um código único pelo WhatsApp e e-mail. Basta clicar no link, ele vai te levar direto para a aula. Sem aplicativos extras, sem downloads.",
      button: "Entendi ✅",
    }
  },
};
